import { Action, getModule, Module } from 'vuex-module-decorators';

import store from '@/store';
import EntityBaseModule from '@/store/entity';

import EntityModel from './entityModel';
import { getById, updateEntity, addNewEntity, removeEntity } from '@/api/crud';

import { Difficulties } from '@/models/difficulties';

export const MODULE_NAME = Difficulties.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class DifficultiesEntityModule extends EntityBaseModule {
    model: any;

    constructor(module: DifficultiesEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(Difficulties.apiPrefix, id);

            return result.difficulty;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: Record<string, any> }) {
        return await updateEntity(Difficulties.apiPrefix, params.id, params.data);
    }

    @Action({ rawError: true })
    async create(data: Record<string, any>) {
        return await addNewEntity(Difficulties.apiPrefix, data);
    }

    @Action({ rawError: true })
    async remove(id: string) {
        return await removeEntity(Difficulties.apiPrefix, id);
    }
}

export default getModule(DifficultiesEntityModule);
